import { connect } from 'react-redux';
import cookies from 'js-cookie';

import { actions as analyticsActions } from '~/analytics-middleware/actions';
import { actions as modalsActions } from '~/modals/reducer';
import { getURL } from '~/server/formatters';

import ConnectChannelModal from './components/connect-channel-prompt';

const connectURL = getURL.getAccountChannelsURL();

export default connect(
  () => {},
  (dispatch) => ({
    closeModal: () => dispatch(modalsActions.hideConnectChannelModal()),
    onConnectChannel: () => {
      dispatch(modalsActions.hideConnectChannelModal());
      window.location.assign(connectURL);
      const hasExperimentSeenExperimentPrompt = cookies.get(
        'GEID6-viewed-prompt'
      );
      if (!hasExperimentSeenExperimentPrompt) {
        cookies.set('GEID6-viewed-prompt', 'viewed', {
          expires: 365,
        });
      }

      const metadata = {
        experimentId: 'GEID6-connect-channel-prompt',
        experimentGroup: 'variant_1',
        sourceFramework: 'albert',
        view: 'connect_channel_prompt',
        firstViewed: !hasExperimentSeenExperimentPrompt,
      };
      dispatch(analyticsActions.trackEvent('Experiment Viewed', metadata));
    },
  })
)(ConnectChannelModal);
